export enum RFASurveySteps {
  Contact = 'rfa/contact',
  Address = 'rfa/address',
  UtilityBills = 'rfa/utility-bills',
}

export const ALL_RFA_STEPS = Object.values(RFASurveySteps);
